import { SettingsSection } from '@components'

import { Button } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceAndProductSettings } from '../../contexts/invoiceAndProductSettingsContext'

export const SectionFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, isProcessing, submitForm } = useInvoiceAndProductSettings()

  const handleSaveButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <SettingsSection.Footer>
      <Button onClick={handleSaveButtonClick} disabled={isLoading} loading={isProcessing}>
        {t('settings.organization.organization_info.submit_button')}
      </Button>
    </SettingsSection.Footer>
  )
}
